<template>
  <div class="bank-flow-detail-page">
    <!-- 页面标题和操作 -->
    <div class="page-header">
      <div class="header-left">
        <a-button @click="$router.back()" style="margin-right: 16px;">
          <a-icon type="left"/>
          返回
        </a-button>
        <h1 class="page-title">银行流水详情 - {{ detailData.bankSerialNo }}</h1>
      </div>
      <div class="header-actions">
<!--        <a-button type="primary" @click="handlePrint">打印</a-button>-->
<!--        <a-button @click="handleExport">导出</a-button>-->
      </div>
    </div>

    <!-- 主要内容 -->
    <div class="detail-content" v-if="detailData">
      <!-- 基本信息卡片 -->
      <a-card title="基本信息" class="detail-card">
        <a-descriptions  size="small" bordered>

          <a-descriptions-item label="清算账号">
            <WalletInfo :account-no="detailData.accountNo" :account-name="detailData.accountName" :showAccountName="true"/>

          </a-descriptions-item>
          <a-descriptions-item label="来账账号">
            <WalletInfo :account-no="detailData.oppAccountNo" :account-name="detailData.oppAccountName" :showAccountName="true" :is-wallet="false"/>
          </a-descriptions-item>

          <a-descriptions-item label="流水状态">
            <a-tag :color="getFlowStatusConfig(detailData.status).color">
              {{ getFlowStatusConfig(detailData.status).label }}
            </a-tag>
          </a-descriptions-item>
          <a-descriptions-item label="来账金额">
            <span class="amount-primary">¥{{ formatAmount(detailData.tradeAmount) }}</span>
          </a-descriptions-item>

<!--          <a-descriptions-item label="已匹配金额">-->
<!--                  <span class="amount-success">-->
<!--                    ¥{{ formatAmount(detailData.matchAmount) }}-->
<!--                  </span>-->
<!--          </a-descriptions-item>-->




          <a-descriptions-item label="来账时间">
            {{ formatDateTime(detailData.tradeTime) }}
          </a-descriptions-item>
          <a-descriptions-item label="来账日期">
            {{ detailData.tradeDate }}
          </a-descriptions-item>
<!--          <a-descriptions-item label="匹配时间">-->
<!--            {{ formatDateTime(detailData.matchTime) || '-' }}-->
<!--          </a-descriptions-item>-->

          <a-descriptions-item label="服务费金额">
            <span class="amount-warning">
              ¥{{ formatAmount(detailData.feeAmount) }}
            </span>
          </a-descriptions-item>
          <a-descriptions-item label="服务费状态">
            <template >
              <a-tooltip v-if="detailData.feeStatus === '2'" :title="detailData.feeFailReason || '-'">
                <a-tag :color="getFeeStatusConfig(detailData.feeStatus).color">
                  {{ getFeeStatusConfig(detailData.feeStatus).label }}
                </a-tag>
                <!-- 重试按钮 -->
                <a-button type="link" size="small" icon="reload" @click="retryFee(detailData)"/>

              </a-tooltip>

              <template v-else>
                <a-tag :color="getFeeStatusConfig(detailData.feeStatus).color">
                  {{ getFeeStatusConfig(detailData.feeStatus).label }}
                </a-tag>
              </template>
            </template>
          </a-descriptions-item>

        </a-descriptions>

      </a-card>




      <!-- 批次明细 -->
      <div v-if="detailData.batchData && detailData.batchData.length > 0">
        <div v-for="batch in detailData.batchData" :key="batch.batchNo" class="batch-section">
          <!-- 批次基本信息 -->
          <a-card
              :title="`批次信息 - ${batch.batchNo}`"
              class="detail-card"
          >
            <a-descriptions :column="3" size="small" bordered>

              <a-descriptions-item label="商户编号">
                {{ batch.merchantNo }}
              </a-descriptions-item>
              <a-descriptions-item label="商户名称">
                {{ batch.merchantName }}
              </a-descriptions-item>

              <a-descriptions-item label="订单笔数">
                {{ batch.orderCount }}
              </a-descriptions-item>

              <a-descriptions-item label="订单金额">
                <span class="amount-primary">¥{{ formatAmount(batch.orderAmount) }}</span>
              </a-descriptions-item>


              <a-descriptions-item label="分账金额">
                <span class="amount-primary">¥{{ formatAmount(batch.splitAmountTotal) }}</span>
              </a-descriptions-item>

              <a-descriptions-item label="登记日期">
                {{ batch.businessDate }}
              </a-descriptions-item>

<!--              <a-descriptions-item label="批次状态">-->
<!--                <a-tag :color="getBatchStatusConfig(batch.batchStatus).color">-->
<!--                  {{ getBatchStatusConfig(batch.batchStatus).label }}-->
<!--                </a-tag>-->
<!--              </a-descriptions-item>-->
<!--              <a-descriptions-item label="作废原因" v-if="batch.invalidReason">-->
<!--                <div style="color: #ff4d4f;">{{ batch.invalidReason }}</div>-->
<!--              </a-descriptions-item>-->
            </a-descriptions>

            <!-- 批次分账明细 -->
            <a-card
                v-if="batch.batchSplitData && batch.batchSplitData.length > 0"
                title="分账计划"
                class="detail-card nested-card"
                :extra="`共 ${batch.batchSplitData.length} 条分账记录`"
            >
              <a-table :dataSource="batch.batchSplitData" :columns="batchSplitColumns" :pagination="false" size="small" bordered
                       :rowKey="(record, index) => record.splitMerchantNo + index">
              </a-table>
            </a-card>
          </a-card>
        </div>
      </div>

      <!-- 清分记录 -->
      <div v-if="detailData.settleData && detailData.settleData.length > 0">
        <div v-for="settle in detailData.settleData" :key="settle.settleSerialNo" class="settle-section">
          <!-- 清分记录基本信息 -->
          <a-card
              :title="`清分记录 - ${settle.settleSerialNo} - ${settle.batchNo}`"
              class="detail-card"
          >

            <a-descriptions :column="3" size="small" bordered>
              <a-descriptions-item label="清算账号">
                {{ settle.settleAccountNo }}
              </a-descriptions-item>
              <a-descriptions-item label="待清算户">
                {{ settle.settleAccountName }}
              </a-descriptions-item>
              <a-descriptions-item label="清算金额">
                <balance prefix="¥" :amount="settle.settleAmount" align-right inline/>
              </a-descriptions-item>

              <a-descriptions-item label="清算状态">
                <a-popover placement="top" v-if="settle.settleStatus === '2'">
                  <a-tag color={this.settle_status(settle.settleStatus).color}>{this.settle_status(settle.settleStatus).label}</a-tag>
                  <template slot="content">
                    <p>失败原因：{settle.failReason}</p>

                  </template>
                </a-popover>
                <a-tag :color="settle_status(settle.settleStatus).color" v-if="settle.settleStatus !== '2'">
                  {{ settle_status(settle.settleStatus).label }}
                </a-tag>

              </a-descriptions-item>

              <a-descriptions-item label="确认时间">
                {{ formatDateTime(settle.generateTime) }}
              </a-descriptions-item>
              <a-descriptions-item label="清算时间">
                {{ formatDateTime(settle.settleTime) || '-' }}
              </a-descriptions-item>

            </a-descriptions>

            <!-- 清分明细 -->
            <a-card
                v-if="settle.itemData && settle.itemData.length > 0"
                title="清分明细"
                class="detail-card nested-card"
                :extra="`共 ${settle.itemData.length} 条明细记录`"
            >
              <a-table
                  :dataSource="settle.itemData"
                  :columns="settleItemColumns"
                  :pagination="false"
                  size="small"
                  bordered
                  :rowKey="(record, index) => record.id + index"
              >
              </a-table>
            </a-card>
          </a-card>
        </div>
      </div>

      <!-- 无数据提示 -->
      <a-card v-if="!hasAnyData" class="detail-card">
        <a-empty description="暂无批次明细和清分记录"/>
      </a-card>
    </div>

    <!-- 加载状态 -->
    <div v-else class="loading-state">
      <a-spin size="large" tip="加载中..."/>
    </div>
  </div>
</template>

<script>
import {message} from 'ant-design-vue';
import moment from 'moment';
import WalletInfo from "@/view/components/WalletInfo.vue";
import Balance from "@/view/components/Balance.vue";
import {commonDict} from "@/utils/bizDict/commonDict";


export default {
  name: 'BankFlowDetail',
  components: {WalletInfo, Balance},
  data() {
    return {
      detailData: null,
      loading: false,

      // 分账明细表格列配置
      batchSplitColumns: [

        {
          title: '商户编号',
          dataIndex: 'splitMerchantNo',
          width: 180,
          align: "center"
        },

        {
          title: '商户名称',
          dataIndex: 'splitMerchantName',
          width: 180,
          align: "center"
        },


        {
          title: '分账模式',
          dataIndex: 'splitMode',
          width: 100,
          align: "center",
          customRender: (text, record) => {
            return (
                <a-tag color={record.splitMode === '0' ? 'blue' : 'green'} size="small">
                  {record.splitMode === '0' ? '指定金额' : '按比例'}
                </a-tag>
            )
          }
        },
        {
          title: '分账比例',
          dataIndex: 'splitRatio',
          width: 100,
          align: "center",
          customRender: (text, record) => {
            if (record.splitMode === '1') {
              return <span>{(record.splitRatio * 100).toFixed(2)}%</span>
            }
            return <span>-</span>
          }
        },
        {
          title: '分账金额',
          dataIndex: 'splitAmount',
          width: 120,
          align: "center",
          customRender: (text, record) => {
            if (record.splitMode === '1') {
              return <span>-</span>
            }
            return <Balance amount={record.splitAmount}  />
          }
        },
        {
          title: '分账说明',
          dataIndex: 'splitDesc',
          width: 120,
          align: "center",
        },


      ],

      // 清分明细表格列配置
      settleItemColumns: [
        {
          title: '主商户信息',
          dataIndex: 'mainMerchantName',
          width: 180,
          align: "center",
          customRender: (text, record) => {
            return (
                <div>
                  <div style={{fontWeight: 'bold', marginBottom: '4px'}}>
                    {record.mainMerchantNo}
                  </div>
                  <div style={{color: '#666', fontSize: '12px'}}>
                    {record.mainMerchantName}
                  </div>
                </div>

            );
          }
        },
        {
          title: '分商户信息',
          dataIndex: 'splitMerchantName',
          width: 180,
          align: "center",
          customRender: (text, record) => {
            return (

                <div>
                  <div style={{fontWeight: 'bold', marginBottom: '4px'}}>
                    {record.splitMerchantNo}
                  </div>
                  <div style={{color: '#666', fontSize: '12px'}}>
                    {record.splitMerchantName}
                  </div>
                </div>
            );
          }

        },
        {
          title: '付款',
          dataIndex: 'accountName',
          width: 200,
          align: "center",
          customRender: (text, record) => {
            return (<WalletInfo accountNo={record.accountNo} accountName={record.accountName} showAccountName={true} size="small"/>);
          }
        },
        {
          title: '收款',
          dataIndex: 'oppAccountName',
          width: 200,
          align: "center",
          customRender: (text, record) => {
            return (<WalletInfo accountNo={record.oppAccountNo} accountName={record.oppAccountName} showAccountName={true} size="small"/>);
          }
        },
        {
          title: '清算金额',
          dataIndex: 'amount',
          width: 120,
          align: "center",
          customRender: (text, record) => {
            return <Balance amount={record.amount} />
          }
        },


        {
          title: '清算状态',
          dataIndex: 'settleStatus',
          width: 120,
          align: "center",
          customRender: (text, record) => {
            if (record.settleStatus === '2') {
              return <a-popover placement="top">
                <a-tag color={this.settle_status(text).color}>{this.settle_status(text).label}</a-tag>
                <template slot="content">
                  <p>失败原因：{record.failReason}</p>

                </template>
              </a-popover>
            } else {
              return <a-tag color={this.settle_status(text).color}>{this.settle_status(text).label}</a-tag>
            }
          },
        },

        {
          title: '摘要',
          align: "center",
          dataIndex: 'remark',
          width: 120,
        },
      ],
    };
  },

  computed: {
    // 是否有任何数据
    hasAnyData() {
      return this.detailData?.batchData?.length > 0 || this.detailData?.settleData?.length > 0;
    }
  },

  mounted() {
    this.loadDetailData();
  },

  methods: {
    async loadDetailData() {
      this.loading = true;
      try {
        const bankSerialNo = this.$route.query.bankSerialNo;
        const response = await this.api.bankFlowDetailApi(bankSerialNo);

        if (response.code === 200) {
          this.detailData = response.data;
        } else {
          message.error('获取详情失败');
        }
      } catch (error) {
        console.error('加载详情失败:', error);
        message.error('加载详情失败');
      } finally {
        this.loading = false;
      }
    },

    async retryFee(){
      try {
        const bankSerialNo = this.$route.query.bankSerialNo;
        const response = await this.api.bankFlowFeeRetryApi(bankSerialNo);

        if (response.code === 200) {
          this.detailData = response.data;
        } else {
          message.error('操作失败');
        }
      } catch (error) {
        console.error('操作失败:', error);
        message.error('操作失败');
      }
    },

    handlePrint() {
      window.print();
    },

    handleExport() {
      message.info('导出功能开发中...');
    },


    // 状态配置方法
    getFlowStatusConfig(status) {
      return commonDict.flow_status[status] || commonDict.flow_status.default;
    },

    getBatchStatusConfig(status) {
      return commonDict.flow_status[status] || commonDict.flow_status.default;
    },


    settle_status(status) {
      return commonDict.settle_status[status] || commonDict.settle_status.default;
    },


    getFeeStatusConfig(status) {
      return commonDict.flowFee_status[status] || commonDict.flowFee_status.default;

    },



    formatAmount(amount) {
      if (!amount) return '0.00';
      return Number(amount).toFixed(2);
    },

    formatDateTime(dateTime) {
      if (!dateTime) return '-';
      return moment(dateTime).format('YYYY-MM-DD HH:mm:ss');
    },
  },
};
</script>

<style scoped>
.bank-flow-detail-page {
  padding: 24px;
  background: #f0f2f5;
  min-height: 100vh;
}

.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  padding: 16px 24px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.header-left {
  display: flex;
  align-items: center;
}

.page-title {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: #262626;
}

.header-actions {
  display: flex;
  gap: 12px;
}

.detail-content {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.detail-card {
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.nested-card {
  margin-top: 16px;
  border-left: 3px solid #1890ff;
  background: #fafafa;
}

.batch-section,
.settle-section {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.info-group {
  margin-bottom: 16px;
}

.info-group:last-child {
  margin-bottom: 0;
}

.info-group-title {
  margin: 0 0 8px 0;
  font-size: 14px;
  font-weight: 600;
  color: #262626;
  padding: 4px 0;
  border-bottom: 1px solid #f0f0f0;
}

.detail-card >>> .ant-card-head {
  background: #fafafa;
  border-bottom: 1px solid #e8e8e8;
}

.detail-card >>> .ant-card-head-title {
  font-weight: 600;
  color: #262626;
}

.highlight-text {
  font-weight: 600;
  color: #1890ff;
}

.amount-primary {
  color: #1890ff;
  font-weight: 600;
}

.amount-success {
  color: #52c41a;
  font-weight: 600;
}

.amount-warning {
  color: #faad14;
  font-weight: 600;
}

.amount-large {
  font-size: 16px;
  font-weight: bold;
}

/* 表格单元格样式优化 */
.merchant-info {
  line-height: 1.4;
}

.merchant-type {
  font-size: 12px;
  color: #666;
  margin-bottom: 2px;
}

.merchant-no {
  font-weight: 600;
  margin-bottom: 2px;
}

.merchant-name {
  font-size: 12px;
  color: #666;
}

.account-info {
  line-height: 1.4;
}

.account-item {
  margin-bottom: 2px;
}

.account-no {
  font-size: 12px;
  color: #666;
  margin-top: 2px;
}

.label {
  color: #666;
  font-size: 12px;
}

.split-info {
  line-height: 1.4;
}

.split-mode {
  margin-bottom: 4px;
}

.split-ratio {
  font-size: 12px;
  color: #666;
  margin-bottom: 2px;
}

.split-amount {
  margin-top: 2px;
}

.split-desc {
  font-size: 12px;
  color: #666;
}

.status-info {
  line-height: 1.4;
}

.fail-reason {
  font-size: 12px;
  color: #ff4d4f;
  margin-top: 4px;
  line-height: 1.2;
}

.time-text {
  font-size: 12px;
  color: #666;
}

.order-no {
  font-size: 12px;
  color: #666;
  word-break: break-all;
}

.time-info {
  line-height: 1.4;
}

.time-item {
  margin-bottom: 2px;
}

.wallet-trade {
  font-size: 11px;
  color: #999;
  margin-top: 4px;
}

.system-info {
  line-height: 1.4;
}

.system-item {
  margin-bottom: 2px;
  font-size: 12px;
}

.record-status {
  margin-top: 4px;
}

.remark-text {
  font-size: 12px;
  color: #666;
}

.loading-state {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 400px;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .bank-flow-detail-page {
    padding: 16px;
  }

  .page-header {
    flex-direction: column;
    gap: 16px;
    align-items: flex-start;
  }

  .header-actions {
    width: 100%;
    justify-content: flex-end;
  }

  .nested-card {
    margin-left: 8px;
  }
}

/* 打印样式 */
@media print {
  .page-header,
  .header-actions {
    display: none;
  }

  .bank-flow-detail-page {
    padding: 0;
    background: white;
  }

  .detail-card {
    box-shadow: none;
    border: 1px solid #ddd;
    margin-bottom: 16px;
    page-break-inside: avoid;
  }

  .nested-card {
    margin-left: 16px;
    border-left: 2px solid #1890ff;
  }
}
</style>